/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';
import { CollectionResult } from './sessionModels';

const URL = process.env.REACT_APP_PORTAL_URL;
const ALL = { offset: 0, limit: 100000 };

export type Team = {
  id: string;
  name: string;
  keeperColor?: string | null;
  playerColor?: string | null;
  optaUid?: string | null;
  abbreviation?: string | null;
};

export type Pitch = {
  id: number;
  name: string;
  type?: string | null;
  fieldLength?: number | null;
  fieldWidth?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  timeZone?: string | null;
  metadata?: string | null;
};

export type Account = {
  id: string;
  type: string;
  name: string;
  bucket?: string | null;
};

export type Player = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  keeper: boolean;
  knownAs?: string | null;
  lastKnownNumber?: number | null;
  optaUid?: string | null;
  lastKnownTeamId?: string | null;
  lastKnownTeam?: { id: string; name?: string | null } | null;
};

export type PlayerInput = {
  firstName: string;
  lastName: string;
  knownAs: string;
  keeper: boolean;
};

const items = async <T>(url: string, params: object = {}): Promise<T[]> => {
  const result: CollectionResult<T> = await axios.get(url, { params: { ...ALL, ...params } });
  return result.items;
};

export default {
  getTeams(): Promise<Team[]> {
    return items<Team>(`${URL}/api/v1/teams`);
  },
  addTeam(name: string): Promise<Team> {
    return axios.post(`${URL}/api/v1/teams`, { name });
  },
  getPitches(): Promise<Pitch[]> {
    return items<Pitch>(`${URL}/api/v1/pitches`, { generated: false });
  },
  getAccounts(): Promise<Account[]> {
    return items<Account>(`${URL}/api/v1/accounts`);
  },
  getPlayers(): Promise<Player[]> {
    return items<Player>(`${URL}/api/v1/players`);
  },
  addPlayer(input: PlayerInput): Promise<Player> {
    return axios.post(`${URL}/api/v1/players`, input);
  },
};
